export enum ClientClassificationType {
  AssessedProfessional = 'AssessedProfessional',
  DeemedProfessional = 'DeemedProfessional',
  MarketCounterparty = 'MarketCounterparty',
  Retail = 'Retail',
}
